<template>
  <div class="alarm-wrapper">
    <div class="alarm-inner">
      <div class="sticky-area">
        <CommonHeader title="알림" :is-back-btn="true" :back-fn="close" :is-close-btn="true" :close-fn="close"></CommonHeader>
        <div class="alarm-wrap">
          <div class="alarm-top">
            <button type="button" class="alarm-setting-btn" @click.prevent="deleteAllAlarms" :disabled="showEmptyList">
              <span>모두삭제</span>
            </button>
            <button type="button" class="alarm-setting-btn" @click.prevent="showAlarmConfig">
              <AlarmIcon />
              <span>알림설정</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="alarm-list"
             v-infinite-scroll="loadMore"
             :infinite-scroll-distance="300"
             :infinite-scroll-throttle-delay="100">
          <my-pooq-empty-list v-if="showEmptyList" info-text="알림 내역이 없어요."></my-pooq-empty-list>
          <ul>
            <li v-for="(alarm, index) in alarmList" :key="'alarm_' + index"
                :class="alarm.status === 'read' ? 'read' : '' "
                @click.prevent="()=>clickAlarm(alarm)">
              <span class="alarm-info">
                  <span class="alarm-txt" v-html="alarm.content"></span>
                  <span class="alarm-time">{{alarm.datestring}}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <transition
      name="alarm-config"
      enter-active-class="slideInRight"
      leave-active-class="slideOutRight">
        <alarms-setup v-if="isVisibleAlarmConfig" :close-fn="hideAlarmConfig" class="slide-duration"></alarms-setup>
    </transition>
  </div>
</template>

<script>
import AlarmIcon from '@/assets/svg/common/ic_alart_ss.svg'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { MyPooqService } from '@/common/api/api.service'
import { get } from 'lodash'
import { infiniteScroll } from '@/common/directives'
import { mapMutations } from 'vuex'
import AlarmsSetup from '@/views/lnb/AlarmsSetup'
import { parseUrl } from 'query-string'
import { MSG_ASK_DELETE_ALL_ALARMS } from '@/common/constant'
import utils from '@/common/util/utils'
import { displayNone, removeNone } from '@/common/util/ui.utils'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import { isApp } from '@/common/util/common'
import CommonHeader from '@/components/header/template/commonHeader'

export default {
  name: 'Alarms',
  components: {
    CommonHeader,
    AlarmsSetup,
    AlarmIcon,
    MyPooqEmptyList
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      alarmList: [],
      offset: 0,
      limit: 20,
      endOfList: false,
      showEmptyList: false,
      isVisibleAlarmConfig: false
    }
  },
  methods: {
    ...mapMutations(['hideAlarms']),
    appAlarm () {
      location.href = ''
    },
    moveToContents (alarm) {
      const { url, query } = parseUrl(alarm.targeturl)
      if (alarm.alarmtype === 'baseball_live') {
        location.href = 'captvpooq://' + alarm.targeturl.replace('www.wavve.com/', '')
      } else {
        let section = url.split('/').pop().replace('.html', '')
        this.$router.push({
          name: PATH_NAME_PLAYER,
          params: { section: section },
          query: query
        })
      }
    },
    clickAlarm (alarm) {
      if (isApp()) {
        const url = alarm.targeturl.replace('www.wavve.com/', '').replace('.html', '')
        location.href = `captvpooq://${url}`
      } else {
        this.moveToContents(alarm)
      }
    },
    async deleteAllAlarms () {
      if (await utils.asyncConfirm(MSG_ASK_DELETE_ALL_ALARMS)) {
        MyPooqService.deleteAllAlarms({ status: 'all' }).then(() => {
          this.offset = 0
          this.limit = 20
          this.endOfList = false
          this.alarmList = []
          this.showEmptyList = false
          this.setData()
        })
      }
    },
    showAlarmConfig () {
      displayNone('.alarm-inner')
      this.isVisibleAlarmConfig = true
    },
    hideAlarmConfig () {
      removeNone('.alarm-inner')
      this.isVisibleAlarmConfig = false
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      MyPooqService.getAlarms({ offset: this.offset, limit: this.limit }).then(({ data }) => {
        let resList = get(data, 'list', [])
        this.endOfList = resList.length === 0
        this.showEmptyList = this.alarmList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.alarmList = this.alarmList.concat(resList)
      })
    },
    close () {
      if (isApp()) {
        location.href = 'captvpooq://webclose'
      } else {
        this.$router.back()
      }
    }
  },
  mounted () {
    MyPooqService.markReadAllAlarms()
  }
}
</script>

<style scoped>
  .alarm-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    z-index: 3000;
  }
  .alarm-inner{
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .fixed-header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
  }
  .alarm-wrap {
    position: -webkit-sticky;
    position: sticky;
    top: 56px;
    z-index: 10;
  }
  .content-body {
    flex: 1;
    position: relative;
    width: 100%;
    overflow-scrolling: touch;
  }
  .content-body::-webkit-scrollbar {
    display: none;
    background-color: transparent
  }
  /*------------------------------------*\
      알림
  \*------------------------------------*/

  /* 알림 상단 모두삭제, 알림설정 버튼 */
  .alarm-top {
    display: flex;
    justify-content: space-between;
    padding: 12px 15px;
    background-color: #1b1b1b;
    font-size: 12px;
    line-height: 18px;
    color: #a5a5a5;
  }
  .alarm-setting-btn{
    height: 16px;
    font-size: 0;
  }
  .alarm-setting-btn svg,
  .alarm-setting-btn span {
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    line-height: 16px;
    color: #a5a5a5;
  }
  .alarm-setting-btn svg{
    margin-right: 5px;
  }
  .alarm-list {
    position: relative;
    width: 100%;
    height: 100%;
  }
  /* 알림 리스트 */
  .alarm-list ul {
    display: flex;
    flex-direction: column;
  }

  .alarm-list li {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px 15px;
    border-bottom: 1px #252525 solid;
    background-color: #252525;
  }

  .alarm-list li.read {
    border-bottom-color: #2f2f2f;
    background-color: transparent;
  }

  .alarm-list .alarm-info {
    flex: 1;
    display: block;
  }

  .alarm-list .alarm-txt {
    display: block;
    display: -webkit-box;
    vertical-align: middle;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #a5a5a5;
    font-size: 14px;
    line-height: 18px;
  }

  .alarm-time {
    display: block;
    margin-top: 5px;
    color: #717171;
    font-size: 12px;
    line-height: 14px;
  }
  .slide-duration {
    animation-duration: 450ms;
  }

</style>
